import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Dimmer, Loader } from 'semantic-ui-react';
import useSlackOAuthStart from './useSlackOAuthStart';
import { isNil } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { appRoutes } from '../../path';

const FixedDimmer = styled(Dimmer)`
  &&& {
    position: fixed;
  }
`;

export default () => {
  const { startSlackOAuth, startSlackOAuthLoading } = useSlackOAuthStart();
  const navigate = useNavigate();

  const callbackRef = useRef(async () => {
    const authorizeUrl = await startSlackOAuth();
    if (!isNil(authorizeUrl)) {
      window.location.href = authorizeUrl;
    } else {
      // there must be some kind of error if there is no authorize URL,
      // open the personal preferences page, where Slack management is
      // configurable
      navigate(appRoutes.settings.preferences);
    }
  });

  // execute once - on mount
  useEffect(() => {
    callbackRef.current();
  }, []);

  return startSlackOAuthLoading ? (
    <FixedDimmer active>
      <Loader />
    </FixedDimmer>
  ) : null;
};
